// extracted by mini-css-extract-plugin
module.exports = {"title":"edit_name__title___qr9eE _type__vx_text-2___Qizsf","save-button":"edit_name__save-button___35vib"};